// extracted by mini-css-extract-plugin
export default {"button":"tl-z","reviewSort":"ul-z"};